//!#system	

<template>
	<v-card>
		<v-card-title>
			<span class="headline">Remote Service Details</span>
		</v-card-title>
		<v-progress-linear v-if="isLoading" indeterminate color="cyan"></v-progress-linear>

		<v-form>
			<v-card-text>
				<div v-for="(header, index) in model.headers" :key="index + '-header'">
					<v-text-field 
						:label="'Header-name:'+index"
						v-model="header.name"
						hint="The header name"
					/>
					<v-text-field 
						:label="'Header-value:'+index"
						v-model="header.value"
						hint="The header name"
					/>
					<v-btn style="float: right;" x-small @click="removeHeader(index)">Remove header</v-btn>
					<div style="clear: both;"></div>
				</div>
				<v-btn x-small @click="addHeader">Add header</v-btn>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="closeDialog()">Exit</v-btn>
				<v-btn color="primary" :disabled="!canSubmit" @click="doAction()">{{submitText}}</v-btn>
			</v-card-actions>
		</v-form>
	</v-card>
</template>

<script>
import apiService from '@/apiService';
import tools from '@/tools';

const defaultConnectionData = function() {
	return {
		headers: []
	};
};

export default {
	name: 'RemoteServiceDetails',
	props: {
		routeInfo: {
			type: Object
		},
		detail: { // Optional starter object
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			model: !tools.isEmpty(this.detail.webServiceProperties) ? this.detail.webServiceProperties : defaultConnectionData(),
			isLoading: false
		}
	},
	computed: {
		submitText() {
			return 'Save';
		},
		canSubmit() {
			return this.model.headers.length > 0
		}
	},
	methods: {
		doAction() {
			// save the data
			apiService.update({
				...this.routeInfo,
				body: {
					...this.detail,
					webServiceProperties: this.model
				}
			}, (err, response, meta) => {
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: meta.validation ? meta.validation.messages.join('\n') : err  
					});
				} else {
					this.$store.dispatch('app/applyObjectUpdated', {
						show: true,
						text: 'Your data has been updated.'
					});
					this.$emit('refresh');
				}
			})
		},
		closeDialog() {
			this.$emit('close');
		},
		addHeader() {
			this.model.headers.push({
				name: '',
				value: ''
			});
		},
		removeHeader(index) {
			this.$delete(this.model.headers, index);
		}
	}
}
</script>
